import { Component } from '@angular/core';

@Component({
  selector: 'eview-circular-loader',
  templateUrl: './circular-loader.component.html',
  styleUrls: ['./app-circular-loader.scss']
})
export class CircularLoaderComponent {}
